var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.friendlyStatus.text)?_c('v-chip',{attrs:{"outlined":"","small":"","color":_vm.friendlyStatus.color,"label":""}},[_c('span',{class:_vm.textClass},[_vm._v(_vm._s(_vm.friendlyStatus.text))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }